<div class="row">
  <div class="col-12">
    <h1>Platform / State indicator</h1>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <h2>Dot indicator</h2>
    <p>Simple colored got with multiple layout styles. Dot is a set of scss mixins.</p>
    <div>
      <div class="platform-card-table">
        <div><i class="state-indicator-no-indicator"></i> No indicator</div>
        <div><i class="state-indicator-in-progress"></i> In progress</div>
        <div><i class="state-indicator-done"></i> Done</div>
        <div><i class="state-indicator-sent-to-auditor"></i> Sent to auditor</div>
        <div><i class="state-indicator-interaction-needed"></i> Interaction needed</div>
        <div><i class="state-indicator-verified"></i> Verified</div>
      </div>
    </div>

    <h2>Badge indicator</h2>
    <p>Button like state indicator, can be interactive or readonly</p>

    <div class="badge-row">
      <span class="state-indicator-label-green">
        <i><ui-icon key="check"></ui-icon></i>
        <label>Verified</label>
      </span>
      <span class="state-indicator-label-red">
        <i><i class="state-indicator-interaction-needed"></i></i>
        <label>Interaction needed</label>
      </span>
      <span class="state-indicator-label-blue">
        <label>Sent to auditor</label>
      </span>
    </div>
  </div>
</div>
